import store from '@/store';
import zh from './zh';
import en from './en';

const packs = {
  chinese: zh,
  english: en,
};

/** 当前语言包（中文 / 英文），字段路径不变，只切换包 */
export function getLocaleMessages(lang) {
  const key = lang || (store.state && store.state.language) || 'chinese';
  return packs[key] || zh;
}

/**
 * 按路径取值，如 t('nav.home')
 * 第二参数可为语言：t('nav.home', 'english')
 * 变量请在业务代码中拼接，勿写入语言包
 */
export function t(path, lang) {
  if (!path) return '';
  const keys = String(path).split('.');
  const primary = getLocaleMessages(lang);
  let cur = primary;
  let fallback = zh;
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i];
    cur = cur && cur[k];
    fallback = fallback && fallback[k];
  }
  if (cur != null && String(cur).trim() !== '') return cur;
  if (fallback != null && String(fallback).trim() !== '') return fallback;
  return path;
}

/** 按当前语言更新浏览器标签页标题 */
export function updateDocumentTitle(lang) {
  if (typeof document === 'undefined') return;
  document.title = t('siteTitle', lang);
}

export { zh, en };
